var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenChecked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35069_103350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8996 5.00024C11.1279 6.12089 10.9652 7.28595 10.4385 8.30113C9.91181 9.31632 9.05302 10.1203 8.00533 10.5789C6.95764 11.0375 5.78439 11.1231 4.68122 10.8214C3.57806 10.5197 2.61167 9.84894 1.94321 8.92095C1.27475 7.99296 0.944634 6.86386 1.00791 5.72193C1.07118 4.58001 1.52401 3.49428 2.2909 2.64582C3.05778 1.79736 4.09236 1.23745 5.22211 1.05947C6.35185 0.881477 7.50846 1.09617 8.49907 1.66774",
    stroke: "#00A63E",
    strokeWidth: 0.566285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49707 5.5L5.99707 7L10.9971 2",
    stroke: "#00A63E",
    strokeWidth: 0.566285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35069_103350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenChecked);
export default __webpack_public_path__ + "static/media/green_checked.5170947dbe9ecd56ec45cc5d36f2b398.svg";
export { ForwardRef as ReactComponent };